module.exports = __webpack_public_path__ + "static/media/toasty.f8347c84.wav";